// extracted by mini-css-extract-plugin
export default {"delete-btn":"styles_delete-btn__sZRAY","delete-icon":"styles_delete-icon__QxVy1"};